/**
 * Web <-> Native 메시지 타입 상수
 *
 * ⚠ IitpNatvApp 의 `src/webview/bridge/messageTypes.js` 와 항상 동일하게 유지할 것.
 *   한쪽만 고치면 메시지가 조용히 무시된다.
 */
const MessageTypes = Object.freeze({
    // Web -> Native (Image Picker)
    IMAGE_PICK_GALLERY: 'IMAGE_PICK_GALLERY',
    IMAGE_PICK_CAMERA: 'IMAGE_PICK_CAMERA',

    // Web -> Native (커스텀 카메라 — vision-camera 풀스크린 오버레이)
    CUSTOM_CAMERA_OPEN: 'CUSTOM_CAMERA_OPEN',

    // Web -> Native (FoodLens)
    FOODLENS_SET_ENGINE: 'FOODLENS_SET_ENGINE',
    FOODLENS_SET_LANGUAGE: 'FOODLENS_SET_LANGUAGE',
    FOODLENS_SET_IMAGE_RESIZE: 'FOODLENS_SET_IMAGE_RESIZE',
    FOODLENS_SET_NUTRITION: 'FOODLENS_SET_NUTRITION',
    FOODLENS_PREDICT: 'FOODLENS_PREDICT',
    FOODLENS_SET_CANDIDATE: 'FOODLENS_SET_CANDIDATE',
    FOODLENS_SEARCH: 'FOODLENS_SEARCH',
    FOODLENS_FOOD_INFO: 'FOODLENS_FOOD_INFO',

    // Web -> Native (삼성 헬스 — 걸음수. 동의는 걸음수·운동·혈압을 한 번에 받는다)
    HEALTH_AVAILABILITY: 'HEALTH_AVAILABILITY',
    HEALTH_PERMISSION_STATUS: 'HEALTH_PERMISSION_STATUS',
    HEALTH_PERMISSION_REQUEST: 'HEALTH_PERMISSION_REQUEST',
    HEALTH_STEPS: 'HEALTH_STEPS',
    HEALTH_STEPS_SUMMARY: 'HEALTH_STEPS_SUMMARY',

    // Web -> Native (삼성 헬스 — 운동 기록. 걸음수와 권한이 따로다)
    HEALTH_EXERCISE_AVAILABILITY: 'HEALTH_EXERCISE_AVAILABILITY',
    HEALTH_EXERCISE_PERMISSION_STATUS: 'HEALTH_EXERCISE_PERMISSION_STATUS',
    HEALTH_EXERCISE_PERMISSION_REQUEST: 'HEALTH_EXERCISE_PERMISSION_REQUEST',
    HEALTH_EXERCISE_SESSIONS: 'HEALTH_EXERCISE_SESSIONS',

    // Web -> Native (삼성 헬스 — 혈압. 운동과 권한이 또 따로다)
    HEALTH_BP_PERMISSION_STATUS: 'HEALTH_BP_PERMISSION_STATUS',
    HEALTH_BP_PERMISSION_REQUEST: 'HEALTH_BP_PERMISSION_REQUEST',
    HEALTH_BP_READINGS: 'HEALTH_BP_READINGS',

    // Web -> Native (기타)
    LOG: 'LOG',
    PHONE_CALL: 'PHONE_CALL',
    LAUNCH_APP: 'LAUNCH_APP',

    // Web -> Native (카카오 네이티브 로그인)
    REQUEST_KAKAO_LOGIN: 'REQUEST_KAKAO_LOGIN',

    // Web -> Native (푸시 알림 권한 / FCM 토큰. REQUEST 는 팝업, CHECK 는 조회만)
    REQUEST_NOTIFICATION_PERMISSION: 'REQUEST_NOTIFICATION_PERMISSION',
    CHECK_NOTIFICATION_PERMISSION: 'CHECK_NOTIFICATION_PERMISSION',
    OPEN_APP_SETTINGS: 'OPEN_APP_SETTINGS',

    // Native -> Web (Image Picker)
    IMAGE_PICK_RESULT: 'IMAGE_PICK_RESULT',
    IMAGE_PICK_ERROR: 'IMAGE_PICK_ERROR',

    // Native -> Web (FoodLens)
    FOODLENS_RESULT: 'FOODLENS_RESULT',
    FOODLENS_ERROR: 'FOODLENS_ERROR',

    // Native -> Web (삼성 헬스)
    // 응답은 { kind, requestId, data } / { kind, requestId, code, error } 한 쌍으로만 온다.
    // 어느 요청에 대한 답인지는 requestId 로 맞춘다.
    HEALTH_RESULT: 'HEALTH_RESULT',
    HEALTH_ERROR: 'HEALTH_ERROR',

    // Native -> Web (카카오 네이티브 로그인)
    KAKAO_LOGIN_SUCCESS: 'KAKAO_LOGIN_SUCCESS',
    KAKAO_LOGIN_FAILURE: 'KAKAO_LOGIN_FAILURE',

    // Native -> Web (푸시 알림. ⚠ 이 응답만 평평하다 — { type, granted, token })
    NOTIFICATION_PERMISSION_RESULT: 'NOTIFICATION_PERMISSION_RESULT',

    // Web -> Native (보류 중인 알림 경로 요청)
    PUSH_NAVIGATE_PENDING: 'PUSH_NAVIGATE_PENDING',

    // Native -> Web (알림 탭 → 화면 이동. payload 는 푸시의 data)
    PUSH_NAVIGATE: 'PUSH_NAVIGATE',
});

export default MessageTypes;
